import React, { useState, useEffect } from "react";
import ipvLogo from "../../IPV-PNG-logo-White-Cropped 1.png";
import bgimage from "../../Background GIF.gif";
import bgimage1 from "../../Background-image.jpg";
import ProgressBar from "./ProgressBar";
import info from "../../InfoSaved.png";
import StartupSectorDropdown from "./StartupSectorDropdown";
import InterestAreaDropdown from "./InterestAreaDropdown";

const ProfessionalSection = ({ formData, onNext, onPrevious, onSaveDraft }) => {
  const [localFormData, setLocalFormData] = useState({ ...formData });
  const [showDraftImage, setShowDraftImage] = useState(false);

  useEffect(() => {
    const savedData = localStorage.getItem("professionalData");
    if (savedData) {
      setLocalFormData(JSON.parse(savedData));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = { ...localFormData, [name]: value };
    setLocalFormData(updatedFormData);
    localStorage.setItem("professionalData", JSON.stringify(updatedFormData));
  };

  const handleSaveDraft = () => {
    localStorage.setItem("professionalData", JSON.stringify(formData));
    setShowDraftImage(true);
    setTimeout(() => setShowDraftImage(false), 3000);
  };

  const handleNext = () => {
    const requiredFields = {
      currentCompany: "Current Company",
      currentDesignation: "Current Designation",
      startupsector: "Startup Sector",
      investedBefore: "Have you invested in startups before ?",
      amtPlanned: "Amount Planned to be Invested in an Year ?",
      netassets:
        "My net assets worth excluding my current residential property is ?",
      interestArea: "Area of Interest",
      support:
        "Willing to support IPV in building a community of like-minded investors ?",
    };

    for (let field in requiredFields) {
      const value = localFormData[field];

      if (
        value === undefined ||
        value === null || // Handles undefined and null
        (typeof value === "string" && value.trim() === "") || // Handles empty string or spaces
        (Array.isArray(value) && value.length === 0) // Handles empty array
      ) {
        alert(`"${requiredFields[field]}" is a required field.`);

        // Auto-focus on the missing input field if it exists
        const inputElement = document.querySelector(`[name="${field}"]`);
        if (inputElement) inputElement.focus();

        return;
      }
    }

    onSaveDraft(localFormData);
    onNext();
  };

  return (
    <div className="personal-container">
      <div className="main-wrapper">
        <img
          loading="lazy"
          src={bgimage}
          className="background-image"
          alt="background"
        />
        <div className="header-content">
          <img
            loading="lazy"
            src={bgimage1}
            className="background-image"
            alt="background"
          />
          <img
            loading="lazy"
            src={ipvLogo}
            alt="IPV Logo"
            className="ipv-logo"
          />
        </div>
        <div className="form-section">
          <form className="form-layout">
            <ProgressBar currentStep={2} />
            <div className="form-container">
              <div className="form-title">Professional Details</div>
              <div className="form-content">
                <div className="form-row">
                  <div className="input-group">
                    <label className="input-label" htmlFor="currentCompany">
                      Current Company*
                    </label>
                    <input
                      id="currentCompany"
                      name="currentCompany"
                      className="input-field"
                      type="text"
                      placeholder="Current Company"
                      value={localFormData.currentCompany || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="currentDesignation">
                      Current Designation*
                    </label>
                    <input
                      id="currentDesignation"
                      name="currentDesignation"
                      className="input-field"
                      type="text"
                      placeholder="Current Designation"
                      value={localFormData.currentDesignation || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Additional fields */}
                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="qualification">
                      Educational Qualification
                    </label>
                    <input
                      id="qualification"
                      name="qualification"
                      className="input-field"
                      type="text"
                      placeholder="Educational Qualification"
                      value={localFormData.qualification || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="undergraduate">
                      Name of Under Graduation College
                    </label>
                    <input
                      id="undergraduate"
                      name="undergraduate"
                      className="input-field"
                      type="text"
                      placeholder="Under Graduation College"
                      value={localFormData.undergraduate || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="postgraduate">
                      Name of Post Graduation College
                    </label>
                    <input
                      id="postgraduate"
                      name="postgraduate"
                      className="input-field"
                      type="text"
                      placeholder="Post Graduation College"
                      value={localFormData.postgraduate || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-container">
              <div className="form-title">Investment Preferences</div>
              <div className="form-content">
                {/* First Question: Have you invested in startups before? */}
                <div className="form-row">
                  <StartupSectorDropdown
                    value={localFormData.startupsector || []}
                    onChange={(selectedValues) => {
                      setLocalFormData({
                        ...localFormData,
                        startupsector: selectedValues,
                      });
                    }}
                  />
                </div>
                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="investedBefore">
                      Have you invested in startups before ?*
                    </label>
                    <select
                      id="investedBefore"
                      name="investedBefore"
                      className="input-field dropdown-select"
                      value={localFormData.investedBefore || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Choose Yes or No
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>
                {/* Second Question: Part of any other platform (Only if answered Yes above) */}
                {localFormData.investedBefore === "yes" && (
                  <div className="section-gap">
                    <div className="input-group">
                      <label className="input-label" htmlFor="otherPlatform">
                        Part of any other platform ?
                      </label>
                      <input
                        type="text"
                        id="otherPlatform"
                        name="otherPlatform"
                        className="input-field"
                        placeholder="Write platform name"
                        value={localFormData.otherPlatform || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}
                <div className="section-gap">
                  <div className="input-group">
                    <label className="input-label" htmlFor="amtPlanned">
                      Amount Planned to be Invested in an Year ?*
                    </label>
                    <select
                      id="amtPlanned"
                      name="amtPlanned"
                      className="input-field dropdown-select"
                      value={localFormData.amtPlanned || ""}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Option...
                      </option>
                      <option value="5 to 10 Lakhs">5 to 10 Lakhs</option>
                      <option value="10 to 15 Lakhs">10 to 15 Lakhs</option>
                      <option value="15 to 20 Lakhs">15 to 20 Lakhs</option>
                      <option value="Above 20 Lakhs">Above 20 Lakhs</option>
                    </select>
                  </div>
                  <div className="input-group">
                    <label className="input-label" htmlFor="netassets">
                      My net assets worth excluding my current residential
                      property is ?*
                    </label>
                    <select
                      id="netassets"
                      name="netassets"
                      className="input-field dropdown-select"
                      value={localFormData.netassets || ""}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Option...
                      </option>
                      <option value="Less than 2Cr">Less than 2Cr</option>
                      <option value="More than 2Cr and less than 7.5Cr">
                        More than 2Cr and less than 7.5Cr
                      </option>
                      <option value="7.5Cr or above">7.5Cr or above</option>
                    </select>
                  </div>
                </div>
                {/* Third Question: Area of Interest (Always visible) */}
                <div className="section-gap">
                  <InterestAreaDropdown
                    value={localFormData.interestArea || []}
                    onChange={(selectedValues) =>
                      setLocalFormData({
                        ...localFormData,
                        interestArea: selectedValues,
                      })
                    }
                  />
                  <div className="input-group">
                    <label className="input-label" htmlFor="support">
                      Willing to support IPV in building a community of
                      like-minded investors ?*
                    </label>
                    <select
                      id="support"
                      name="support"
                      className="input-field dropdown-select"
                      value={localFormData.support || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Choose Yes or No
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      <option value="May be Later">May Be Later</option>
                    </select>
                  </div>
                </div>

                <div className="section-gap"></div>
              </div>
            </div>

            {showDraftImage && (
              <div className="draft-toast-fullscreen">
                <img
                  src={info}
                  alt="Draft saved"
                  className="draft-toast-image"
                />
              </div>
            )}
            <div className="button-wrapper">
              <button
                type="button"
                className="filled-button"
                onClick={onPrevious}
              >
                Previous
              </button>
              <button
                type="button"
                className="outlined-button"
                onClick={handleSaveDraft}
              >
                Save Draft
              </button>
              <button
                type="button"
                className="filled-button"
                onClick={handleNext}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalSection;
